import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'spark-nmb-store-details',
  templateUrl: './store-details.component.html',
  styleUrls: ['./store-details.component.scss']
})
export class NmbStoreDetailsComponent {
  constructor() {}

  public onClick(): void {
    window.open('https://www.nmb.com.au/nmb/access/brokerlogon.asp?url=%2fnmb%2fBrokers%2fdefault%2Easp', '_blank');
  }
}
